<template>
  <div id="adminTickets">
    <app-menu></app-menu>
    <admin-list-component
        :title="'Admin.menu.tickets' | staticTranslation"
        :add-text="'Admin.components.addTicket' | staticTranslation"
        edit-path="/admin/ticket/edit/"
        entity-name="ticket"
        :get-name-function="getName"
        draggable="true"
    />
  </div>
</template>

<script>
import AdminListComponent from "@/components/admin/AdminListComponent";
import AdminMenu from "@/components/admin/AdminMenu";

export default {
  name: "AdminTickets",
  components: {
    'app-menu': AdminMenu,
    'admin-list-component': AdminListComponent
  },
  methods: {
    getName: function (ticket) {
      return ticket.title;
    }
  }
}
</script>

<style scoped>
#adminTickets {
  background-color: white;
  min-height: 100vh;
  overflow: hidden;
}
</style>
